var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVLo6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prima-Versione",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ANTICIPO-TFS---DOCUMENTI",
    transform: "translate(-1091 -1683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v_lo_6",
    transform: "translate(1094 1686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(19.998 24.042)",
    fill: "#FCBB00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9971209 12.0210574C30.683693 12.0210574 27.997629 9.33005208 27.997629 6.0105287 27.997629 2.69100531 30.683693 0 33.9971209 0 37.3105489 0 39.9966128 2.69100531 39.9966128 6.0105287 39.9966128 9.33005208 37.3105489 12.0210574 33.9971209 12.0210574zM5.99949193 12.0210574C2.68606398 12.0210574 0 9.33005208 0 6.0105287 0 2.69100531 2.68606398 0 5.99949193 0 9.31291987 0 11.9989839 2.69100531 11.9989839 6.0105287 11.9989839 9.33005208 9.31291987 12.0210574 5.99949193 12.0210574z",
    id: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.4926516,69.2111044 C52.3339355,83.5963027 27.7360554,83.5963027 12.5373427,69.2111044 C-3.90126569,53.6237995 -4.18129034,27.6584502 11.7373616,11.7505841 C27.336041,-3.91686105 52.6939533,-3.91686105 68.2926327,11.7505841 C84.1712881,27.6584502 83.8912625,53.6237995 67.4926516,69.2111044 Z",
    id: "Vector",
    stroke: "#FCBB00",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.0819672,52.4590164 C46.7445904,61.2021858 33.2160824,61.2021858 24.9180328,52.4590164",
    id: "Vector",
    stroke: "#FCBB00",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVLo6);
export default __webpack_public_path__ + "static/media/v_lo_6.f62b5f485bb26d709fc626a0b2c18a55.svg";
export { ForwardRef as ReactComponent };